import { svg } from 'lit';

const symbol = svg`<svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.5" cy="7.5" r="6.5" stroke="currentcolor"/><path d="M7.274 10.816V6.395h.91v4.42h-.91zM7.13 4.78a.59.59 0 01.594-.597c.335 0 .603.265.603.597a.59.59 0 01-.603.587.582.582 0 01-.594-.587z" fill="currentcolor"/><path d="M7.867 6.395h-2.21v.737h2.21v-.737z" fill="currentcolor"/></svg>`;

export { symbol as default };
